export default "__VITE_ASSET__$i94h0rg__"